import React, { useState, useEffect, useRef } from 'react';


const MusicPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(0);
  const [tracks, setTracks] = useState([
    { title: 'Track 1', artist: 'Artist 1', src: 'https://dailymusicroll.s3.us-west-2.amazonaws.com/wp-content/uploads/2024/04/06184330/Breaking-Down-Justin-Biebers-Emotional-Instagram-Update.mp3' },
    { title: 'Track 2', artist: 'Artist 2', src: 'https://dailymusicroll.s3.us-west-2.amazonaws.com/wp-content/uploads/2024/03/10164150/Mariah-Careys-Fabulous-55th-Anniversary-Boat-Soiree.mp3' },
    { title: 'Track 3', artist: 'Artist 3', src: 'https://dailymusicroll.s3.us-west-2.amazonaws.com/wp-content/uploads/2022/07/26220917/texas-state-university-is-going-to-launch-a-new-course-on-harry-styles.mp3' },
  ]);

  const currentAudio = useRef(null);

  useEffect(() => {
    currentAudio.current = new Audio();
  }, []);

  useEffect(() => {
    if (currentAudio.current) {
      currentAudio.current.pause();
      currentAudio.current.src = tracks[currentTrack].src;
      currentAudio.current.play();
      setIsPlaying(true);
    }
  }, [currentTrack]);

  const handlePlayPause = () => {
    if (isPlaying) {
      currentAudio.current.pause();
    } else {
      currentAudio.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleNextTrack = () => {
    setCurrentTrack((prevTrack) => (prevTrack + 1) % tracks.length);
  };

  const handlePrevTrack = () => {
    setCurrentTrack((prevTrack) => (prevTrack - 1 + tracks.length) % tracks.length);
  };

  const handleTrackChange = (index) => {
    setCurrentTrack(index);
  };

  return (
    <div className="music-player">
      <div className="player-controls">
        <button onClick={handlePrevTrack}>Prev</button>
        <button onClick={handlePlayPause}>{isPlaying ? 'Pause' : 'Play'}</button>
        <button onClick={handleNextTrack}>Next</button>
      </div>
      <div className="track-info">
        <h2>{tracks[currentTrack].title}</h2>
        <p>{tracks[currentTrack].artist}</p>
      </div>
      <div className="track-list">
        <ul>
          {tracks.map((track, index) => (
            <li key={index} onClick={() => handleTrackChange(index)}>
              {track.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MusicPlayer;